import request from '../../../../../shared/lib/request';
import { API } from '../../../../../shared/constants';


const getAll = () => request(
  {
    url: API.PROFILO_INTERNO,
    method: 'GET',
  });

const getAllOptions = () => getAll().then(
    (res) => res._embedded.profilo_interno.map((obj)=>{ return {value: obj.id, label: obj.nome }}) // eslint-disable-line
  ).then((data) => ({ options: data }));


const ProfilointernoService = {
  getAll,
  getAllOptions,
};

export default ProfilointernoService;



// WEBPACK FOOTER //
// ./app/shared/services/api/internokiron/profilo/index.js